import { SET_MYSHIPMENTS, SET_NEWSHIPMENTS, SET_OFFERS } from './mutation-types'
import slug from 'slug'

/**
 * Query all new shipments
 */
export function searchShipments({ commit }) {
  // Ajax query shipments
  return new Promise((resolve, reject) => {
    this._vm.$http
      .get('/api/shipment/dispatchradius')
      .then(response => {
        commit(SET_NEWSHIPMENTS, response.data)
      })
      .catch(err => {
        console.log(err)
      })
  })
}

/**
 * Query all shipments of this company
 */
export function getMyShipments({ commit }) {
  // Ajax query shipments
  return new Promise((resolve, reject) => {
    this._vm.$http
      .get('/api/shipment/driverdispatch')
      .then(response => {
        commit(SET_MYSHIPMENTS, response.data)
      })
      .catch(err => {
        console.log(err)
      })
  })
}

/**
 * Query all offers of this company
 *
 * @param {params} id the user id
 */
export function getOffers({ commit }) {
  // Ajax query offers
  return new Promise((resolve, reject) => {
    this._vm.$http
      .get('/api/offer/dispatchpending')
      .then(response => {
        commit(SET_OFFERS, response.data)
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * place an offer on a shipment
 *
 * @param {params} id the user id
 */
export function placeOffer({ commit }, params) {
  return new Promise((resolve, reject) => {
    this._vm.$http
      .post('/api/shipment/' + params.shipment_id + '/dispatchoffer', {
        price: params.price
      })
      .then(() => {
        this.dispatch('searchShipments')
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * assign driver
 *
 * @param {params} id the user id
 */
export function assignDriver({ commit }, params) {
  return new Promise((resolve, reject) => {
    this._vm.$http
      .post('/api/shipment/' + params.shipment_id + '/dispatchassign', {
        driver_id: params.driver_id,
        offer_id: params.offer_id
      })
      .then(response => {
        this.dispatch('getMyShipments')
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * cancel an offer on a shipment
 *
 * @param {params} id the user id
 */
export function cancelOffer({ commit }, offer_id) {
  return new Promise((resolve, reject) => {
    this._vm.$http
      .delete('/api/offer/' + offer_id)
      .then(response => {
        this.dispatch('searchShipments')
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * cancel an offer on a shipment
 *
 * @param {params} id the user id
 */
export function rateSender({ commit }, params) {
  return new Promise((resolve, reject) => {
    this._vm.$http
      .post('/api/rating',
      {
        rating: params.rating,
        shipment_id: params.shipment_id
      },
      {
        headers: { Impersonate: params.user_id }
      })
      .then(response => {
        this.dispatch('getMyShipments')
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * update shipment states as a dispatcher
 *
 * @param {params} id the user id
 */
export function updateStates({ commit }, params) {
  return new Promise((resolve, reject) => {
    let headers = {
      headers: {
        Impersonate: params.user_id
      }
    }

    let content = {
      shipmentid: params.shipment_id,
      states: [
        {
          state: params.state,
          timestamp: params.timestamp,
          app_uid: params.app_uid
        }
      ]
    }

    if (params.attachments && params.attachments.length) {
      headers.headers['Content-Type'] = 'multipart/form-data'
      let formData = new FormData() // eslint-disable-line
      let attachments = []

      params.attachments.forEach((file, idx) => {
        let fileName = slug(file.name)
        attachments.push({
          file: fileName,
          type: 'cmr',
          order: idx + 1
        })
        formData.append(fileName, file)
      })

      content['attachments'] = attachments

      formData.append('content', JSON.stringify(content))
      content = formData
    }

    this._vm.$http
      .post('/api/shipment/states', content, headers)
      .then(response => {
        this.dispatch('getMyShipments')
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
}
